import { render, staticRenderFns } from "./ContentFields.vue?vue&type=template&id=1f625808&scoped=true"
import script from "./ContentFields.vue?vue&type=script&lang=js"
export * from "./ContentFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f625808",
  null
  
)

export default component.exports